// extracted by mini-css-extract-plugin
export default {"title":"LV08_WejlHj9f92uvF2i","consumptionContainer":"iRvT7zCWY_cDaCBCZWfv","infoBox":"VrY2UL_UH87OAkHsXsXn","listBox":"mZP9kK8AKbdmOueU23hX"};